/* eslint-disable no-param-reassign */
export default {
  setPreselected(state, payload) {
    state.preselected = {
      ...payload,
    };
  },
  setLastUsed(state, payload) {
    state.lastUsed = {
      ...payload,
    };
  },
};
